import { getStatusColor } from '../../utils/timelineHelpers';
import { mapReferralStatus } from '../../../services/utils';
import { TYPOGRAPHY, BORDER_RADIUS } from '../../constants/theme';

const StatusPill = ({ status, company }) => {
  if (!status || status === '-') {
    return null;
  }

  const color = getStatusColor(status);
  const mappedStatus = mapReferralStatus(status, company);

  return (
    <span
      style={{
        display: 'inline-block',
        padding: '2px 6px',
        borderRadius: BORDER_RADIUS.SMALL,
        backgroundColor: `${color}15`,
        color: color,
        fontSize: TYPOGRAPHY.FONT_SIZES.XS,
        border: `1px solid ${color}30`
      }}
    >
      {mappedStatus}
    </span>
  );
};

export default StatusPill;
